import {Controller} from "@hotwired/stimulus"
import flatpickr from "flatpickr";

// Connects to data-controller="acs--tenant-flatpickr"
export default class extends Controller {

    static targets = ["validFrom", "validTill"];

    connect() {
        this.initValidFromPicker();
        if (this.validFromTarget.value){
            flatpickr(this.validFromTarget, {
                dateFormat: "Y-m-d",
                onChange: this.handleValidFromChange.bind(this),
            }).setDate(this.validFromTarget.value, true);
        }

    }

    initValidFromPicker() {
        flatpickr(this.validFromTarget, {
            dateFormat: "Y-m-d",
            onChange: this.handleValidFromChange.bind(this),
        });
    }

    handleValidFromChange(selectedDates) {
        if (selectedDates.length > 0) {
            let selectedDate = selectedDates[0];
            let maxDate = new Date(selectedDate);
            let minDate = new Date(selectedDate);
            maxDate.setFullYear(selectedDate.getFullYear() + 1);
            minDate.setFullYear(selectedDate.getFullYear())
            this.initValidTillPicker(maxDate, minDate);
        }
    }

    initValidTillPicker(maxDate, minDate) {
        flatpickr(this.validTillTarget, {
            dateFormat: "Y-m-d",
            minDate: minDate,
            maxDate: maxDate,
        });
    }


}
